// @flow
import OrgsSettings from './OrgsSettings';
import sections, { defaultSection } from './sections';
import { dataKey } from './dataKey';

export default OrgsSettings;
export { defaultSection, dataKey, sections };
